import React from 'react';
import { Language } from '../types';
import { useTranslation } from '../utils/translations';

interface QuickQuestionsProps {
  onQuestionClick: (question: string) => void;
  language: Language;
  disabled?: boolean;
}

const QuickQuestions: React.FC<QuickQuestionsProps> = ({
  onQuestionClick,
  language,
  disabled = false
}) => {
  const t = useTranslation(language);

  const questions = [
    t('quick.question.1'),
    t('quick.question.2'),
    t('quick.question.3'),
    t('quick.question.4'),
  ];

  return (
    <div className="mb-4 sm:mb-6">
      <h3 className="text-xs sm:text-sm font-medium text-gray-700 mb-2 sm:mb-3 px-1 sm:px-2">
        {t('quick.questions')}
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5 sm:gap-2">
        {questions.map((question, index) => (
          <button
            key={index}
            onClick={() => onQuestionClick(question)}
            disabled={disabled}
            className="text-left p-2 sm:p-3 bg-white border border-gray-200 rounded-lg hover:border-blue-300 hover:bg-blue-50 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed text-xs sm:text-sm"
          >
            <div className="flex items-start space-x-1.5 sm:space-x-2">
              <div className="flex-shrink-0 w-1.5 h-1.5 sm:w-2 sm:h-2 bg-blue-500 rounded-full mt-1.5 sm:mt-2"></div>
              <span className="text-gray-700 leading-relaxed">{question}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickQuestions;

